export function parseAxisValues(raw: string): number[] {
  const text = raw.trim();
  if (!text) return [];
  const values: number[] = [];
  for (const token of text.split(",").map((part) => part.trim()).filter(Boolean)) {
    const range = token.split(":").map(Number);
    if (range.length === 3 && range.every(Number.isFinite)) {
      const [start, stop, step] = range as [number, number, number];
      if (step === 0 || Math.sign(stop - start) !== Math.sign(step)) {
        throw new Error(`invalid range ${token}`);
      }
      const epsilon = Math.abs(step) * 1e-9;
      for (let value = start; step > 0 ? value <= stop + epsilon : value >= stop - epsilon; value += step) {
        values.push(Number(value.toPrecision(12)));
        if (values.length > 500) throw new Error("a sweep axis may contain at most 500 values");
      }
      continue;
    }
    const value = Number(token);
    if (!Number.isFinite(value)) throw new Error(`invalid number ${token}`);
    values.push(value);
  }
  return [...new Set(values)];
}

export function humanBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 ** 2) return `${(bytes / 1024).toFixed(1)} KiB`;
  if (bytes < 1024 ** 3) return `${(bytes / 1024 ** 2).toFixed(1)} MiB`;
  return `${(bytes / 1024 ** 3).toFixed(1)} GiB`;
}

export function triangulateCells(cells: number[][]): number[] {
  const indices: number[] = [];
  for (const cell of cells) {
    for (let i = 1; i + 1 < cell.length; i += 1) {
      indices.push(cell[0]!, cell[i]!, cell[i + 1]!);
    }
  }
  return indices;
}
